import { Component, OnInit } from '@angular/core';
import { commit, date, version } from 'git-version';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  commit = commit;
  version = version;
  date = date;

  constructor() { }

  ngOnInit() {
  }

}
